import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapPaymentTypeFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    const: mapField("const"),
});

export const mapPaymentTypesFromServer = mapArray(mapPaymentTypeFromServer);
